import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d7a7906"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xag-flex-vertical detail-box" }
const _hoisted_2 = { class: "detail-header" }
const _hoisted_3 = { class: "h-1 detail-name-wrap" }
const _hoisted_4 = { class: "h-2" }
const _hoisted_5 = { class: "rate-dis xag-flex-center" }
const _hoisted_6 = { class: "val" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "服务评价", -1))
const _hoisted_8 = { class: "val" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "距离", -1))
const _hoisted_10 = { class: "cell-box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "服务情况", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "可用备用产品", -1))
const _hoisted_13 = { class: "label xag-flex" }
const _hoisted_14 = {
  key: 1,
  class: "cell-item xag-flex service"
}
const _hoisted_15 = { class: "val" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "待接单", -1))
const _hoisted_17 = { class: "val" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "服务中", -1))
const _hoisted_19 = { class: "val" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "维修工程师", -1))
const _hoisted_21 = { class: "val" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "可用备用产品", -1))
const _hoisted_23 = { class: "cell-box" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "网点信息", -1))
const _hoisted_25 = { class: "cell-item info" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "电话", -1))
const _hoisted_27 = { class: "val xag-flex-lr" }
const _hoisted_28 = { class: "xag-flex-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "地址", -1))
const _hoisted_30 = { class: "val xag-flex-lr" }
const _hoisted_31 = { class: "xag-flex-center" }
const _hoisted_32 = { class: "cell-box" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "网点服务", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "设备故障报修", -1))
const _hoisted_35 = {
  key: 1,
  class: "label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_NameTag = _resolveComponent("NameTag")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_van_loading, {
          key: 0,
          class: "xag-flex-center",
          style: {"width":"100%","height":"100%"}
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, _toDisplayString(_ctx.item.name), 1),
              (_ctx.showUpdateing)
                ? (_openBlock(), _createBlock(_component_NameTag, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.item.subTypeName) + " | " + _toDisplayString(_ctx.item.address), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.item.evaluation !== '0.0' ? `${_ctx.item.evaluation}分` : '暂无评分'), 1),
                _hoisted_7
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.item.dis), 1),
                _hoisted_9
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              (_ctx.item.sub_type === 'auth_warehouse')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "cell-item xag-flex-lr backup",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onToBackUp && _ctx.onToBackUp(...args)))
                  }, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.item.backup_count) + "个", 1),
                      _createVNode(_component_van_icon, {
                        name: "arrow",
                        style: {"margin-left":"2px"}
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.item.wait_receive) + "单", 1),
                      _hoisted_16
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.item.repairing) + "单", 1),
                      _hoisted_18
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.item.repairers) + "人", 1),
                      _hoisted_20
                    ]),
                    _createElementVNode("div", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onToBackUp && _ctx.onToBackUp(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _createTextVNode(_toDisplayString(_ctx.item.backup_count) + "个", 1),
                        _createVNode(_component_van_icon, {
                          name: "arrow",
                          style: {"margin-left":"2px"}
                        })
                      ]),
                      _hoisted_22
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCallPoint && _ctx.onCallPoint(...args)))
                }, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.item.contact_phone), 1),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_van_icon, { name: "/images/icon_dianhua.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onNavigatePoint && _ctx.onNavigatePoint(...args)))
                }, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.item.address), 1),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_van_icon, { name: "/images/icon_daohang.svg" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", {
                class: "cell-item xag-flex-lr devices",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onTodevices && _ctx.onTodevices(...args)))
              }, [
                (_ctx.item.status)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_34,
                      _createVNode(_component_van_icon, { name: "arrow" })
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.showUpdateing ? '网点升级建设中，请选择其他网点' : '服务地点调整中，暂无法提供服务'), 1))
              ])
            ])
          ])
        ], 64))
  ]))
}